import { type ListCar } from '../_types/Car';

const listCarNull: ListCar = null;
const listCarEmpty: ListCar = {};
const listCarNullContentLevel0: ListCar = {
    id: null,
    idFirma: null,
    ident: null,
    hersteller: null,
    modell: null,
    mod_o: null,
    mod_g: null,
    name: null,
    typ: null,
    preis: null,
    ez: null,
    km: null,
    idGF: null,
    farbe: null,
    tueren: null,
    engine: null,
    getriebe: null,
    siegel: null,
    garantie: null,
    nfz: null,
    idStandort: null,
    vorbesitzer: null,
    aktion: null,
    sonderangebot: null,
    bilder: null,
    link: null,
    loc: null,
    finanzierung: null,
    leasing: null,
};
const listCarEmptyContentLevel0: ListCar = {
    id: 0,
    idFirma: 0,
    ident: '',
    hersteller: '',
    modell: '',
    mod_o: '',
    mod_g: '',
    name: '',
    typ: '',
    preis: {},
    ez: '',
    km: 0,
    idGF: 0,
    farbe: [],
    tueren: 0,
    engine: {},
    getriebe: '',
    siegel: [],
    garantie: [],
    nfz: null,
    idStandort: 0,
    vorbesitzer: 0,
    aktion: '',
    sonderangebot: '',
    bilder: {},
    link: '',
    loc: {},
    finanzierung: {},
    leasing: {},
};
const listCarNullContentLevel1: ListCar = {
    id: 227590817,
    idFirma: 9800,
    ident: '5628',
    hersteller: 'VW',
    modell: 'Polo',
    mod_o: 'Polo',
    mod_g: 'Polo',
    name: 'VW Polo 1.0 TSI Comfortline PDC Sitzheizung',
    typ: 'Gebrauchtfahrzeug',
    preis: {
        mwst: 1,
        mwst_satz: 19.0,
        vk: 12346,
        vkn: 10374,
        upe: 12665,
    },
    ez: '01.05.2018',
    km: 49808,
    idGF: 14,
    farbe: ['Weiß', 'Weiß'],
    tueren: 4,
    engine: {
        motor: null,
        kraftstoff: null,
        hubraum: null,
        leistung: null,
        verbrauch: null,
        effizienz: null,
    },
    getriebe: 'manuell',
    siegel: [0, 'kein Siegel'],
    garantie: [0, '(keine Garantie)'],
    nfz: false,
    idStandort: 0,
    vorbesitzer: 1,
    aktion: '0',
    sonderangebot: '0',
    bilder: {
        anzahl: null,
        url: null,
        ec: null,
    },
    link: '/search/car_227590817&w=68',
    loc: {
        id: null,
        name: null,
        str: null,
        plz: null,
        ort: null,
        tel: null,
        mail: null,
    },
    finanzierung: {
        effektiver_jahreszins: null,
        monatliche_rate: null,
        laufzeit: null,
        anzahlung: null,
        km: null,
        schlussrate: null,
        bruttokreditbetrag: null,
        abschlussgebühr: null,
        ksb: null,
        ksb_betrag: null,
        nettrokreditbetrag: null,
        anbieterbank: null,
        soll_zinssatz: null,
        art_sollzinssatzes: null,
    },
    leasing: {
        DestinationCharges: null,
        ExtraMileageCosts: null,
        LowMileageCompensation: null,
        RegistrationFees: null,
        TotalAmount: null,
        anzahlung: null,
        effektiver_jahreszins: null,
        km: null,
        laufzeit: null,
        nettrokreditbetrag: null,
        soll_zinssatz: null,
        monatliche_rate: null,
    },
};
const listCarEmptyContentLevel1: ListCar = {
    id: 227590817,
    idFirma: 9800,
    ident: '5628',
    hersteller: 'VW',
    modell: 'Polo',
    mod_o: 'Polo',
    mod_g: 'Polo',
    name: 'VW Polo 1.0 TSI Comfortline PDC Sitzheizung',
    typ: 'Gebrauchtfahrzeug',
    preis: {
        mwst: 1,
        mwst_satz: 19.0,
        vk: 12346,
        vkn: 10374,
        upe: 12665,
    },
    ez: '01.05.2018',
    km: 49808,
    idGF: 14,
    farbe: ['Weiß', 'Weiß'],
    tueren: 4,
    engine: {
        motor: '',
        kraftstoff: '',
        hubraum: 0,
        leistung: [],
        verbrauch: [],
        effizienz: '',
    },
    getriebe: 'manuell',
    siegel: [0, 'kein Siegel'],
    garantie: [0, '(keine Garantie)'],
    nfz: false,
    idStandort: 0,
    vorbesitzer: 1,
    aktion: '0',
    sonderangebot: '0',
    bilder: {
        anzahl: 0,
        url: [],
        ec: null,
    },
    link: '/search/car_227590817&w=68',
    loc: {
        id: 0,
        name: '',
        str: '',
        plz: '',
        ort: '',
        tel: '',
        mail: '',
    },
    finanzierung: {
        effektiver_jahreszins: 0,
        monatliche_rate: 0,
        laufzeit: 0,
        anzahlung: 0,
        km: '',
        schlussrate: 0,
        bruttokreditbetrag: 0,
        abschlussgebühr: 0,
        ksb: '',
        ksb_betrag: '',
        nettrokreditbetrag: '',
        anbieterbank: '',
        soll_zinssatz: '',
        art_sollzinssatzes: '',
    },
    leasing: {
        DestinationCharges: '',
        ExtraMileageCosts: '',
        LowMileageCompensation: '',
        RegistrationFees: '',
        TotalAmount: '',
        anzahlung: '',
        effektiver_jahreszins: '',
        km: '',
        laufzeit: '',
        nettrokreditbetrag: '',
        soll_zinssatz: '',
        monatliche_rate: '',
    },
};
const listCarFull: ListCar = {
    id: 227590817,
    idFirma: 9800,
    ident: '10',
    hersteller: 'VW',
    modell: 'Golf',
    mod_o: 'Golf',
    mod_g: 'Golf',
    name: 'VW Golf 1.5 TSI Life Active LED KAMERA NAVI Pimped-18',
    typ: 'Gebrauchtfahrzeug',
    mwst: 19.0,
    vkn: 10374,
    upe: 12665,
    // @ts-expect-error type diff TODO
    preis: 12346,
    ez: '01.05.2018',
    km: 2000,
    idGF: 14,
    farbe: ['Rot', 'Metallic'],
    tueren: 4,
    engine: {
        motor: 'Plug-In-Hybrid Benzin/Elektro',
        kraftstoff: 'Super E10',
        kraftstoff_1: 'Strom',
        hubraum: 999,
        leistung: [70, 95],
        verbrauch: [4.4, 104],
        effizienz: 'A',
    },
    getriebe: 'manuell',
    siegel: [0, 'kein Siegel'],
    garantie: [0, '(keine Garantie)'],
    nfz: false,
    idStandort: 0,
    vorbesitzer: 1,
    aktion: '0',
    sonderangebot: '0',
    bilder: {
        anzahl: 27,
        url: [
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18858286/1731426560691/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933748/1717695849679/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18858285/1717695851234/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933749/1717695851791/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933750/1717695852294/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933751/1717695852589/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933752/1717695852853/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933753/1717695853120/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933754/1717695853380/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933755/1717695853599/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933756/1717695853915/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933757/1717695854283/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933758/1717695854528/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933759/1717695854810/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933760/1717695855111/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/18933761/1717695855509/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/20366918/1717695855725/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/21743060/1717695855966/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/21743058/1717695856157/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/21743059/1717695856363/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/21743065/1717695856691/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/21743061/1717695856963/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/21743063/1717695857272/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/21743064/1717695857572/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/21743062/1717695857860/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/21744256/1736957880440/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/-13160/1662977627000/640',
            'https://p.autohaus-digital.de/s/v3/imgc/9800/21744258/1717681349181/640',
        ],
        ec: true,
    },
    link: '/search/car_227590817&w=68',
    loc: {
        id: 0,
        name: 'Autohaus Digital',
        str: 'Christian-Wehner-Str. 2',
        plz: '09113',
        ort: 'Chemnitz',
        tel: '+49 371 256202 70',
        mail: 'sales@ahdmail.de',
    },
    finanzierung: {
        effektiver_jahreszins: 2.79,
        monatliche_rate: 125,
        laufzeit: 48,
        anzahlung: 1776.47,
        km: '10000',
        schlussrate: 1114.65,
        bruttokreditbetrag: 7114.65,
        abschlussgebühr: 0,
        ksb: 'kein',
        ksb_betrag: '0.00',
        nettrokreditbetrag: '6673.53',
        anbieterbank: 'Volkswagen Bank GmbH, Gifhornerstraße 57, 38112 Braunschweig',
        soll_zinssatz: '2.75',
        art_sollzinssatzes: 'gebunden',
    },
    leasing: {
        DestinationCharges: '0',
        ExtraMileageCosts: '0',
        LowMileageCompensation: '0',
        RegistrationFees: '0',
        TotalAmount: '7114.65',
        anzahlung: '1776.47',
        effektiver_jahreszins: '2.79',
        km: '10000',
        laufzeit: '48',
        nettrokreditbetrag: '6673.53',
        soll_zinssatz: '2.75',
        monatliche_rate: '125 €',
    },
};

const mockListCar = {
    null: listCarNull,
    empty: listCarEmpty,
    nullContentLevel0: listCarNullContentLevel0,
    emptyContentLevel0: listCarEmptyContentLevel0,
    nullContentLevel1: listCarNullContentLevel1,
    emptyContentLevel1: listCarEmptyContentLevel1,
    full: listCarFull,
};

export default mockListCar;
